// extracted by mini-css-extract-plugin
export default {"icon":"FooterButtonsComponent_icon__iH+jl","iconPlus":"FooterButtonsComponent_iconPlus__aNClt","footerButtons":"FooterButtonsComponent_footerButtons__GNin8"};